export default function (Component) {
Component.options.__docs = "<p>The example below is using <code>v-model</code> in order to bind similar component to the same data.</p>\n"
}